var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
var FeedbackStars = function (_a) {
    var score = _a.score, setScore = _a.setScore, onClick = _a.onClick, isReadOnly = _a.isReadOnly, hasFixedScore = _a.hasFixedScore, setHasFixedScore = _a.setHasFixedScore;
    return (_jsx("div", __assign({ className: "flex flex-row space-x-5 items-center cursor-pointer" }, { children: [1, 2, 3, 4, 5].map(function (starCount) {
            return score >= starCount ? (_jsx(StarIcon, { className: "text-mainYellow", onMouseLeave: function () {
                    if (!isReadOnly && !hasFixedScore && setScore) {
                        setScore(0);
                    }
                }, onClick: onClick
                    ? function () {
                        onClick(starCount);
                    }
                    : undefined }, void 0)) : (_jsx(StarOutlineIcon, { className: "text-mainYellow", onMouseOver: function () {
                    if (!isReadOnly) {
                        setHasFixedScore && setHasFixedScore(false);
                        setScore && setScore(starCount);
                    }
                } }, void 0));
        }) }), void 0));
};
export default FeedbackStars;
